import { VuexModule, Module, Mutation, MutationAction } from 'vuex-module-decorators'
import groupBy from "lodash.groupby"
import sortBy from "lodash.sortby"
import InterestArea from "@/models/InterestArea"
import Brochure from "@/models/Brochure"
import moment from "moment"
import GenericFilter from "@/models/GenericFilter"
import StudyLanguage from "../models/StudyLanguage"
import Params from "@/models/Params"
import StudyType from '@/models/StudyType'
import StudyForm from '@/models/StudyForm'
import Subject from '@/models/Subject'
import * as brochurefilter_helper from "@/helpers/brochurefilter_helper"
import ShippingMethod from '@/models/ShippingMethod'

@Module({ namespaced: true })
export default class BrochureAanvraagModule extends VuexModule {
  loading = true;
  brochuresOnPage = 10;
  interestAreas: InterestArea[] = [];
  brochures: Brochure[] = [];
  studyTypes: StudyType[] = [];
  studyForms: StudyForm[] = [];
  subjects: Subject[] = [];
  shippingMethods: ShippingMethod[] = [];
  studyLanguages: StudyLanguage[] = [];
  studyTypesById: { [id: string]: StudyType } = {};
  studyFormsById: { [id: string]: StudyForm } = {};
  subjectsById: { [id: string]: Subject } = {};
  shippingMethodsById: { [id: string]: ShippingMethod } = {};
  interestAreasById: { [id: string]: InterestArea } = {};
  brochuresById: { [id: string]: Brochure } = {};
  studyLanguagesById: { [id: string]: StudyLanguage } = {};
  allFilteredBrochures: Brochure[] = [];

  filters: {
    VlsCode: string;
    InterestAreas: string[];
    StudyLanguages: string[];
    StudyTypes: string[];
    StudyForms: string[];
    subjects: string[];
    ShippingMethods: string[];
  } = {
      VlsCode: "",
      InterestAreas: [],
      StudyLanguages: [],
      StudyTypes: [],
      StudyForms: [],
      subjects: [],
      ShippingMethods: []
    };
  selectedBrochures: string[] = [];
  searchString = "";

  get VlsBrochures() {
    return this.brochures.filter(s => s.code == this.filters.VlsCode);
  }

  get IsVlsBrochure() {
    return (BrochureId: string) => {
      return (
        this.brochures.filter(
          s => this.filters.VlsCode.length > 0 && s.code == this.filters.VlsCode && s.id == BrochureId
        ).length > 0
      );
    };
  }


  get GetFilteredBrochures() {
    return this.allFilteredBrochures.filter(
      s => this.filters.VlsCode.length == 0 || s.code != this.filters.VlsCode
    );
  }

  get GetFilteredBrochuresCount() {
    return this.allFilteredBrochures.length;
  }


  get studyLanguagesByName() {
    return sortBy(this.studyLanguages, ["name"]);
  }

  get studyTypesByName() {
    return sortBy(this.studyTypes, ["name"]);
  }

  get studyFormsByName() {
    return sortBy(this.studyForms, ["name"]);
  }

  get subjectsByName() {
    return sortBy(this.subjects, ["name"]);
  }

  get shippingMethodsByName() {
    return sortBy(this.shippingMethods, ["name"]);
  }

  get interestAreasByName() {
    return sortBy(this.interestAreas, ["name"]);
  }

  get CurrentNumberOfPages() {
    return Math.ceil(this.allFilteredBrochures.length / this.brochuresOnPage);
  }

  get hasFiltersSelected() {
    return (
      this.filters.InterestAreas.length > 0 ||
      this.filters.StudyForms.length > 0 ||
      this.filters.StudyTypes.length > 0 ||
      this.filters.subjects.length > 0 ||
      this.filters.ShippingMethods.length > 0 ||
      this.filters.StudyLanguages.length > 0
    );
  }

  get FilteredBrochures() {
    return this.brochures
      .filter((brochure: Brochure) => {
        return brochurefilter_helper.BrochureInfilter(brochure, this.searchString, this.filters);
      });
  /*     .sort(function (a, b) {
        const aConcat = a.name;
        const bConcat = b.name;

        if (aConcat > bConcat) {
          return 1;
        } else if (aConcat < bConcat) {
          return -1;
        } else {
          return 0;
        }
      }); */
  }

  @Mutation
  async vlsChanged(value: string) {
    this.filters.VlsCode = value;
  }

  @Mutation
  async searchChanged({ value }: { value: string }) {
    this.searchString = value;

    this.allFilteredBrochures = this.brochures.filter((brochure: Brochure) => {
      return brochurefilter_helper.BrochureInfilter(brochure, this.searchString, this.filters);
    });
/*       .sort((a, b) => {
        const aConcat = a.name;
        const bConcat = b.name;

        if (aConcat > bConcat) {
          return 1;
        } else if (aConcat < bConcat) {
          return -1;
        } else {
          return 0;
        }
      }); */

    this.subjects.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.subject?.id == x.id
      ).length)
    );
    this.studyTypes.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.studytype?.id == x.id
      ).length)
    );
    this.studyForms.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.studyform?.id == x.id
      ).length)
    );
    this.shippingMethods.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.shippingmethod?.id == x.id
      ).length)
    );
    this.interestAreas.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => {
          let infilter = false;
          if (s.interestAreas && s.interestAreas.length > 0) {

            s.interestAreas.forEach(element => {
              if (!infilter && element.id == x.id)
                infilter = true;

            });
          }
          return infilter;
        }
      ).length)
    );

    this.studyLanguages.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(s => {
        if (x.id == "NL") {
          return s.nederlands;

        } else if (x.id == "EN") {
          return s.engels;

        }
      }).length)
    );

  }


  @Mutation
  async setFilter() {


    this.allFilteredBrochures = this.brochures.filter((brochure: Brochure) => {
      return brochurefilter_helper.BrochureInfilter(brochure, this.searchString, this.filters);
    });/* .sort((a, b) => {
      const aConcat = a.name;
      const bConcat = b.name;

      if (aConcat > bConcat) {
        return 1;
      } else if (aConcat < bConcat) {
        return -1;
      } else {
        return 0;
      }
    }); */

    this.subjects.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.subject?.id == x.id
      ).length)
    );
    this.studyTypes.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.studytype?.id == x.id
      ).length)
    );
    this.studyForms.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.studyform?.id == x.id
      ).length)
    );
    this.shippingMethods.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.shippingmethod?.id == x.id
      ).length)
    );
    this.interestAreas.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => {
          let infilter = false;
          if (s.interestAreas && s.interestAreas.length > 0) {

            s.interestAreas.forEach(element => {
              if (!infilter && element.id == x.id)
                infilter = true;

            });
          }
          return infilter;
        }
      ).length)
    );


    this.studyLanguages.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(s => {
        if (x.id == "NL") {
          return s.nederlands;

        } else if (x.id == "EN") {
          return s.engels;

        }
      }).length)
    );
  }

  @Mutation
  async filterChanged({ type, values }: { type: string; values: string[] }) {
    this.filters = Object.assign(this.filters, { [type]: values });

    this.allFilteredBrochures = this.brochures.filter((brochure: Brochure) => {
      return brochurefilter_helper.BrochureInfilter(brochure, this.searchString, this.filters);
    });/* .sort((a, b) => {
      const aConcat = a.name;
      const bConcat = b.name;

      if (aConcat > bConcat) {
        return 1;
      } else if (aConcat < bConcat) {
        return -1;
      } else {
        return 0;
      }
    }); */
  }

  @Mutation
  async recalculateFilters() {

    this.subjects.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.subject?.id == x.id
      ).length)
    );
    this.studyTypes.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.studytype?.id == x.id
      ).length)
    );
    this.studyForms.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.studyform?.id == x.id
      ).length)
    );
    this.shippingMethods.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => s.shippingmethod?.id == x.id
      ).length)
    );
    this.interestAreas.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(
        s => {
          let infilter = false;
          if (s.interestAreas && s.interestAreas.length > 0) {

            s.interestAreas.forEach(element => {
              if (!infilter && element.id == x.id)
                infilter = true;

            });
          }
          return infilter;
        }
      ).length)
    );


    this.studyLanguages.forEach(
      x =>
      (x.count = this.allFilteredBrochures.filter(s => {
        if (x.id == "NL") {
          return s.nederlands;

        } else if (x.id == "EN") {
          return s.engels;

        }
      }).length)
    );
  }

  @Mutation
  async changeSelection({ id, selected }: { id: string; selected: boolean }) {
    if (selected) {
      if (this.selectedBrochures.indexOf(id) === -1)
        this.selectedBrochures = [...this.selectedBrochures, id];
    } else {
      this.selectedBrochures = [...this.selectedBrochures.filter(s => s !== id)];
    }

    const brochureGuidsInput = document.getElementById(
      "crmrhan_brochureguids"
    ) as HTMLInputElement;
    if (brochureGuidsInput) {
      brochureGuidsInput.value = this.selectedBrochures.join(", ") + ",";
    }

  }

  @MutationAction
  async loadBrochureData(lang: string) {

    const interestAreas: InterestArea[] = [];
    const brochures: Brochure[] = [];
    const studyTypes: StudyType[] = [];
    const studyForms: StudyForm[] = [];
    const subjects: Subject[] = [];
    const shippingMethods: ShippingMethod[] = [];
    const studyLanguages: StudyLanguage[] = [];
    const interestAreasById: { [id: string]: InterestArea } = {};
    const brochuresById: { [id: string]: Brochure } = {};
    const studyTypesById: { [id: string]: StudyType } = {};
    const studyFormsById: { [id: string]: StudyForm } = {};
    const subjectsById: { [id: string]: Subject } = {};
    const shippingMethodsById: { [id: string]: ShippingMethod } = {};
    const studyLanguagesById: { [id: string]: StudyLanguage } = {};
    const selectedBrochures: string[] = [];
    const allFilteredBrochures: Brochure[] = [];

    let fetchUrl = `./api/GetBrochuresData/?lang=${lang}&` + moment(new Date()).format("yyyyMMddhhmmssSSSS").toString();

    // Get the brochure data
    const response = await fetch(
      fetchUrl
    );
    const {
      data
    }: {

      data: Brochure[];
    } = await response.json();

    data.forEach(brochure => {
      const {
        interestArea,
        subject,
        studytype,
        studyform,
        shippingmethod
      } = brochure;

      if (brochure.id) {
        brochure.interestAreas = [];
        if (!brochuresById[brochure.id]) {
          if (interestArea) {
            brochure.interestAreas.push(interestArea);
            if (!interestAreasById[interestArea.id]) {
              interestArea.count = 1;
              interestAreas.push(interestArea);
              interestAreasById[interestArea.id] = interestArea;
            } else {
              const ia = interestAreas.find(item => item.id === interestArea.id);
              if (ia != null) ia.count++;
            }
          }

          if (studytype) {
            if (!studyTypesById[studytype.id]) {
              studyTypes.push(studytype);
              studyTypesById[studytype.id] = studytype;
            } else {
              const st = studyTypes.find(item => item.id === studytype.id);
              if (st != null) st.count++;
            }
          }

          if (studyform) {
            if (!studyFormsById[studyform.id]) {
              studyForms.push(studyform);
              studyFormsById[studyform.id] = studyform;
            } else {
              const st = studyForms.find(item => item.id === studyform.id);
              if (st != null) st.count++;
            }
          }

          if (shippingmethod) {
            if (!shippingMethodsById[shippingmethod.id]) {
              shippingMethods.push(shippingmethod);
              shippingMethodsById[shippingmethod.id] = shippingmethod;
            } else {
              const st = shippingMethods.find(item => item.id === shippingmethod.id);
              if (st != null) st.count++;
            }
          }

          if (subject) {
            if (!subjectsById[subject.id]) {
              subjects.push(subject);
              subjectsById[subject.id] = subject;
            } else {
              const st = subjects.find(item => item.id === subject.id);
              if (st != null) st.count++;
            }
          }

          if (brochure.nederlands == true) {
            if (!studyLanguagesById["NL"]) {
              studyLanguages.push({
                id: "NL",
                count: 1,
                name: lang == "nl" ? "Nederlands" : "Dutch"
              });
              studyLanguagesById["NL"] = {
                id: "NL",
                count: 1,
                name: lang == "nl" ? "Nederlands" : "Dutch"
              };
            } else {
              const s = studyLanguages.find(item => item.id === "NL");
              if (s != null) s.count++;
            }
          }

          if (brochure.engels == true) {
            if (!studyLanguagesById["EN"]) {
              studyLanguages.push({ id: "EN", count: 1, name: lang == "nl" ? "Engels" : "English"});
              studyLanguagesById["EN"] = {
                id: "EN",
                count: 1,
                name: lang == "nl" ? "Engels" : "English"
              };
            } else {
              const s = studyLanguages.find(item => item.id === "EN");
              if (s != null) s.count++;
            }
          }

          allFilteredBrochures.push(brochure);
          brochures.push(brochure);
          brochuresById[brochure.id] = brochure;

        } else {
          if (interestArea) {
            const sessie = brochures.find(item => item.id === brochure.id);
            sessie?.interestAreas?.push(interestArea);

            if (!interestAreasById[interestArea.id]) {
              interestArea.count = 1;
              interestAreas.push(interestArea);
              interestAreasById[interestArea.id] = interestArea;
            } else {
              const ia = interestAreas.find(item => item.id === interestArea.id);
              if (ia != null) ia.count++;
            }
          }

        }

      }
    });


    return {
      interestAreas,
      brochures,
      studyTypes,
      studyForms,
      subjects,
      shippingMethods,
      studyLanguages,
      interestAreasById,
      brochuresById,
      studyTypesById,
      studyFormsById,
      subjectsById,
      shippingMethodsById,
      studyLanguagesById,
      selectedBrochures,
      allFilteredBrochures
    };
  }
}
function sort(arg0: (a: any, b: any) => 0 | 1 | -1) {
  throw new Error('Function not implemented.')
}

